function toRad(Value) {
  return Value * (Math.PI / 180);
}

function CalcCrow(coords1lat, coords1lng, coords2lat, coords2lng) {
  var dLat = toRad(coords2lat - coords1lat);
  var dLon = toRad(coords2lng - coords1lng);
  var lat1 = toRad(coords1lat);
  var lat2 = toRad(coords2lat);
  var a =
    Math.sin(dLat / 2) * Math.sin(dLat / 2) +
    Math.sin(dLon / 2) * Math.sin(dLon / 2) * Math.cos(lat1) * Math.cos(lat2);
  var c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
  var d = c;
  var deg = ((d * 180) / Math.PI) * 69;
  return deg;
}

export default CalcCrow;
